import { select } from 'd3';
import { DataDRequest } from "../../../data/DRequest";
import { Entidad } from "../../../data/Entidad";
import { DataModuloMain } from "../../../data/ModuloMain";
import { CBoletaPlantillaBase, IBoletaPlantilla as IBP } from "../../../data/entidad/Boleta";
import { _SvBoletaPlantillaActualizar, _SvBoletaPlantillaAgregar, _SvBoletaPlantillaEliminar, _SvBoletaPlantillaObtenerLista } from "../../../data/modulo/BoletaPlantilla";
import { _DICC_ESCOLARIDAD } from '../../../data/modulo/Escolaridad';
import { _DICC_ESCUELA } from "../../../data/modulo/Escuela";
import { _DICC_GRADO } from "../../../data/modulo/Grado";
import { _DICC_GRUPO } from '../../../data/modulo/Grupo';
import _L from "../../../util/Labels";
import { IConfigCardCollapseExcelExport } from "../../controlD3/CardV1/CardCollapseAdvancedTable";
import { TCARDV2COLL_OnEditOriginEvent } from "../../controlD3/CardV2/CardV2Collapse";
import { CardV2CollapseAdvancedTable } from "../../controlD3/CardV2/CardV2CollapseAdvancedTable";
import { FormGenerator } from "../../controlD3/Formulario";
import { FullViewFile, FullViewItemContent } from "../../controlD3/FullViewFile";
import { NotificacionV2 } from '../../controlD3/NotificacionV2';
import { SelectV2 } from "../../controlD3/SelectV2";
import { Table } from "../../controlD3/Tabla";
import { TablaRowManager } from "../../controlD3/TablaRowManager";
import { HTMLTooltipComponent } from '../../controlWC/TooltipComponent';
import { UIUtilElement } from '../../util/Element';
import { UIUtilPermission } from '../../util/Permission';
import { UIUtilGeneral } from "../../util/Util";
import { UIUtilViewData } from "../../util/ViewData";
import ic_info from '/image/iconos/ic_infomark.svg?raw';

import IEscuela = Entidad.IEscuela;

const ic_template1_01 = 'image/boletas_preview/template1_01.png';
const ic_template1_02 = 'image/boletas_preview/template1_02.png';
const ic_template2_01 = 'image/boletas_preview/template2_01.png';
const ic_template2_02 = 'image/boletas_preview/template2_02.png';
const ic_template2_03 = 'image/boletas_preview/template2_03.png';

type IBoletaPlantilla = IBP & {
    _Plantilla?: string
    _Alcance?: string
}

export class UIPanelCardEscuelasBoletaConfiguracion extends CardV2CollapseAdvancedTable<IBoletaPlantilla, [IEscuela]> {
    constructor() {
        super("", Entidad.CModulo.PanelBoletaConfiguracion);
    }

    protected Table_GetMenuDataSelected(): Array<Table.ITableMenuDataSelectedOptionConfig<IBoletaPlantilla>> {
        let opciones: Array<Table.ITableMenuDataSelectedOptionConfig<IBoletaPlantilla>> = [];

        if (UIUtilPermission._HasAccionPermission(Entidad.CAccionPermiso.Editar, Entidad.CModulo.PanelBoletaConfiguracion, this.cardData[0]?.IdKinder)) {
            opciones.push({
                Label: _L("panelboletaconfiguracion.action_editar"),
                Callback: ([boleta]) => this.OpenModal_ActualizarConfiguracion(boleta)
            })
        }
        if (UIUtilPermission._HasAccionPermission(Entidad.CAccionPermiso.Eliminar, Entidad.CModulo.PanelBoletaConfiguracion, this.cardData[0]?.IdKinder)) {
            opciones.push({
                Label: _L("c_actions.eliminar"),
                Callback: (datos) => this.OpenModal_EliminarDatos(datos)
            })
        }

        return opciones;
    }

    private OpenModal_FormularioAgregar() {
        const [escuela] = this.cardData;
        this.CARDCOLLAD_OpenModal_ActionFormToAGridData({
            Title: _L("panelboletaconfiguracion.action_agregar"),
            // Action: Entidad.CAccionPermiso.Agregar,
            IdsEscuelas: [escuela.IdKinder],
            Width: 620,
            GetForm: () => createForm({
                idEscuela: this.cardData[0].IdKinder,
                getAlreadyConfigs: () => this.ctrlTabla._data
            }),
            OnAccept: (form) => {
                const fData = form._Data
                console.warn(fData)
                return _SvBoletaPlantillaAgregar(escuela.IdKinder, fData.IdPlantilla, fData.Nombre, fData.IdsNivel, fData.IdsGrado, {
                    cabeceras_extras: fData.EncabezadosExtras,
                    rel_1: fData.StaticMateriaMaestro,
                    usaMateriaMaestro: fData.VerMateriaMaestro,
                })
            },
            TypeRequest: null, //Entidad.CTipoRequest.CicloEscolar,
            OnEndReloadService: async () => this.UI_UpdateTable(),
        })
    }

    private OpenModal_EliminarDatos(datos: IBoletaPlantilla[]) {
        this.CARDCOLLAD_OpenModal_ProccessArrayData<IBoletaPlantilla>({
            // Tittle: "Eliminar ciclos escolares",
            Title: _L("c_actions.eliminar"),
            DataToProccess: datos,
            TypeRequest: null, // Entidad.CTipoRequest.CicloEscolar,
            OnGetIdEscuela: (dato) => this.cardData[0].IdKinder,
            OnError_GetItemDataTag: ({ Nombre }) => Nombre,
            OnStepAProccess: (dato) => _SvBoletaPlantillaEliminar(dato.Id),
            OnEndAndCloseProccess: async (_, __, results) => {
                const requireRefresh = results.some(res => (res.Resultado > 0) || (res.Resultado == -1))
                if (requireRefresh) {
                    this.UI_UpdateTable();
                }
            }
        })
    }

    private OpenModal_ActualizarConfiguracion(boleta: IBoletaPlantilla) {
        const idEscuela = this.cardData[0].IdKinder
        this.CARDCOLLAD_OpenModal_ActionFormToAGridData({
            Title: _L("panelboletaconfiguracion.action_editar"),
            TypeRequest: null,
            Width: 620,
            GetForm: () => {
                const form = createForm({
                    idEscuela: this.cardData[0].IdKinder,
                    idBoletaPlantilla: boleta.Id,
                    getAlreadyConfigs: () => this.ctrlTabla._data
                })
                const idsNivel = boleta.IdsNivel || Array.from(_DICC_ESCOLARIDAD.values()).filter(d => d.IdEscuela == idEscuela).map(d => d.Id)
                form._AsignaData({
                    ...boleta,
                    IdsNivel: idsNivel,
                    IdsGrado: boleta.IdsGrado || Array.from(_DICC_GRADO.values()).filter(d => idsNivel.includes(d.IdEscolaridad)).map(d => d.IdNivel),
                    EncabezadosExtras: boleta.Extras.cabeceras_extras,
                    VerMateriaMaestro: boleta.Extras.usaMateriaMaestro,
                    StaticMateriaMaestro: boleta.Extras.rel_1
                })
                return form
            },
            OnAccept: (form, mt) => {
                const fData = form._Data
                console.warn(">>> ", fData)
                // return new Promise(resolve => resolve(null))
                return _SvBoletaPlantillaActualizar(boleta.Id, fData.IdPlantilla, fData.Nombre, fData.IdsNivel, fData.IdsGrado, {
                    cabeceras_extras: fData.EncabezadosExtras,
                    rel_1: fData.StaticMateriaMaestro,
                    usaMateriaMaestro: fData.VerMateriaMaestro,
                })
            },
            OnEndReloadService: async (res) => {
                if (res.Resultado > 0 || res.Resultado == -1) {
                    this.UI_UpdateTable()
                }
                return null
            }
        })
    }

    private UI_UpdateTable(): void {
        const idEscuela = this.cardData[0].IdKinder

        this.ctrlProgress.node()._Visible = true;
        _SvBoletaPlantillaObtenerLista(idEscuela)
            .then(res => {
                const dataFinal = res.Datos.map((d: IBoletaPlantilla) => {

                    // Forma texto "Plantilla"
                    d._Plantilla = UIUtilViewData._GetStr_BoletaPlantillaBase(d.IdPlantilla)

                    // Forma texto "Alcance"
                    d._Alcance = (() => {
                        // Niveles y grados asignados
                        const mainRels = fnGetNivelGradoRel(d)
                        let str = ""
                        if (!d.IdsNivel && !d.IdsGrado) {
                            str = _L("panelboletaconfiguracion.allschool")
                        } else {
                            str = fnGetStrNivelGradoRel(mainRels)
                        }

                        // Excepciones de niveles y grados
                        const excepcionNivelGrado: { [s: number]: Set<number> } = {}
                        res.Datos.forEach(d2 => {
                            if (d2 === d) return

                            const itemRels = fnGetNivelGradoRel(d2)

                            if (mainRels) {
                                const hasMatches = Object.keys(itemRels || {}).some(idNivelA => {
                                    return mainRels[idNivelA] !== undefined
                                })
                                if (!hasMatches) return
                            }

                            for (const key in itemRels) {
                                const idsGrados = itemRels[key]

                                if (idsGrados === null) {
                                    excepcionNivelGrado[key] = null

                                } else if (excepcionNivelGrado[key] !== null) {
                                    if (excepcionNivelGrado[key] === undefined) {
                                        excepcionNivelGrado[key] = new Set()
                                    }

                                    idsGrados.forEach(idGrado => {
                                        if (mainRels && mainRels[key] && !mainRels[key].has(idGrado)) return
                                        excepcionNivelGrado[key].add(idGrado)
                                    })
                                }
                            }
                        })

                        if (Object.values(excepcionNivelGrado).length) {
                            const strExcepciones = fnGetStrNivelGradoRel(excepcionNivelGrado)
                            if (strExcepciones) {
                                str += "\n\n<b>" + _L("panelboletaconfiguracion.excepto") + "</b>\n\n"
                                str += strExcepciones
                            }
                        }

                        return str
                    })()

                    return d
                })
                this.ctrlTabla._UpdateData(dataFinal)
            })
            .finally(() => {
                this.ctrlProgress.node()._Visible = false;
            })

        /** Get names Nivel - Grados relation */
        const fnGetNivelGradoRel = (d2: IBoletaPlantilla): { [idNivel: number]: Set<number> } => {
            const gradoNivel: { [idNivel: number]: Set<number> } = {}

            if (!d2.IdsNivel && !d2.IdsGrado) {
                return null
            }

            if (d2.IdsGrado) {
                d2.IdsGrado.forEach(idGrado => {
                    const grado = _DICC_GRADO.get(idGrado)
                    const nivel = _DICC_ESCOLARIDAD.get(grado?.IdEscolaridad)

                    if (!grado || !nivel) return

                    if (gradoNivel[nivel.Id] !== null) {
                        if (gradoNivel[nivel.Id] === undefined) {
                            gradoNivel[nivel.Id] = new Set()
                        }
                        gradoNivel[nivel.Id].add(grado.IdNivel)
                    }
                })

            } else {
                d2.IdsNivel.forEach(idNivel => {
                    const nivel = _DICC_ESCOLARIDAD.get(idNivel)

                    if (!nivel) return

                    gradoNivel[nivel.Id] = null
                })
            }
            return gradoNivel
        }
        const fnGetStrNivelGradoRel = (rels: { [idNivel: number]: Set<number> }): string => {
            let str = ""
            let i = -1, totalIndex = Object.keys(rels).length - 1
            for (const k in rels) {
                i++
                const idNivel = Number(k)
                const gradosTotales = Array.from(_DICC_GRADO.values())
                    .filter(d => d.IdKinder == idEscuela && idNivel == d.IdEscolaridad)
                const grados = rels[idNivel] !== null ? Array.from(rels[idNivel].values()) : null

                if (grados?.length != 0) {
                    str += `* ${_DICC_ESCOLARIDAD.get(idNivel)?.Nombre}: `
                    if (grados === null || grados.length == gradosTotales.length) {
                        str += "<i>" + _L("panelboletaconfiguracion.allgrades") + "</i>"
                    }
                    else {
                        str += "<i>" + grados.map(idGrado => _DICC_GRADO.get(idGrado)?.Nombre).join(", ") + "</i>"
                    }
                    if (i < totalIndex)
                        str += "\n"
                }
            }
            return str
        }
    }

    protected CARDCOLL_MostrarBody() {
        this.UI_UpdateTable();
        this.cardSelection.style("height", "100%");
        return this;
    }

    protected CARDCOLL_OcultarBody(): void {
        this.cardSelection.style("height", null);
    }
    protected CARDCOLL_OnEditarCard(): void {
        // throw new Error("Method not implemented.");
    }
    protected CARDCOLL_OnCancelaEditarCard(originEvent: TCARDV2COLL_OnEditOriginEvent): void {
    }
    protected CARDCOLL_GuardarCardV2(): Promise<DataDRequest.IRequestResponseA<any>> {
        throw new Error("Method not implemented.");
    }

    protected CARDCOLL_OnInitBuild(contentContainer: TSelectionHTML<"div", any, any>): void {
        this.cardFooterSelection.remove();
        this.btnEditarCard._d3Selection.remove();
        this.cardHeaderSelection.remove();
    }

    protected CARDCOLL_GetVariantToValidateUpdate(cardData_0: IEscuela): string {
        return null;
    }

    protected CARDCOLL_OnUpdateData(cardData_0: IEscuela): void {
        if (this.CARDCOLL_StatusCardExpandido) {
            this.UI_UpdateTable();
        }
    }

    protected CARDCOLL_SyncOrGetIdToDownloadData(): DataModuloMain.TipoRequestMonitorId | (() => Promise<any>) | DataModuloMain.TipoRequestMonitorId[] {
        return Entidad.CTipoRequest.CicloEscolar
    }

    protected CARDCOLL_GetIdSchool(cardData_0_0: IEscuela): number {
        return cardData_0_0.IdKinder;
    }

    protected CARDCOLLADTAB_Table_GetConfig(): Omit<Table.IConfig<IBoletaPlantilla>, keyof Pick<Table.IConfig<IBoletaPlantilla>, "Parent">> {
        return {
            IdTabla: "EscuelasPanelCicloEscolar",
            Title: "",
            IdData: "Id",
            OrderDefault: { Type: Table.CStatusOrder.Asc, Field: "Nombre" },
            MinWidth: 600,
            RenderColumnHeadings: [
                { Field: "Nombre", Label: _L("panelboletaconfiguracion.nombre"), Width: "24%", MinWidth: "75px", },
                { Field: "_Plantilla", Label: _L("panelboletaconfiguracion.plantilla"), Width: "20%", MinWidth: "75px", },
                { Field: "_Alcance", Label: _L("panelboletaconfiguracion.alcance"), Width: "56%", MinWidth: "75px", },
            ],
            OptionsTopDefaultV2: {
                MaxOptionsInRow: 3,
                Options: [] // this.TableGetMenu()
            },
            OptionsOfDataCheckV3: () => {
                if (this.cardData?.length) {
                    return this.CARDCOLLADTAB_GetTableOptionsToSelectedData(this.cardData[0].IdKinder, "top-selected", this.Table_GetMenuDataSelected());
                }
                return null;
            },
            EvaluatorAndSubLevelsBuild: {
                GetOptionsInRowV2: () => this.CARDCOLLADTAB_GetTableOptionsToSelectedData(this.cardData[0].IdKinder, "row", this.Table_GetMenuDataSelected()),
                OnStepRowTable: (d, tr) => tr.on("click", () => console.debug(d.Id, d)),
                OnStepCellTable: (cell, datum, field) => {
                    if (field == "_Alcance") {
                        cell.html(datum[field])
                    }
                }
            }
        }
    }

    protected CARDCOLLADTAB_Table_GetMenuTop(): Table.ITableMenuTopDefaultOptionConfig[] {
        let opciones: Array<Table.ITableMenuTopDefaultOptionConfig> = [];

        if (UIUtilPermission._HasAccionPermission(Entidad.CAccionPermiso.Agregar, Entidad.CModulo.PanelBoletaConfiguracion, this.cardData[0]?.IdKinder)) {
            opciones.push({
                Label: "action_agregar",
                Callback: () => this.OpenModal_FormularioAgregar()
            })
        }

        return opciones;
    }

    protected CARDCOLLADTAB_GetExportarConfig(dataTable: IBoletaPlantilla[]): IConfigCardCollapseExcelExport<IBoletaPlantilla> {
        if (!UIUtilPermission._HasAccionPermission(Entidad.CAccionPermiso.ExportarAExcel, Entidad.CModulo.PanelBoletaConfiguracion, this.cardData[0]?.IdKinder)) {
            return null;
        }
        const escuela = this.cardData[0];
        return {
            FileName: escuela.Nombre + " - " + _L("panelboletaconfiguracion.export_filename"),
            IdsEscuelas: [escuela.IdKinder],
            TypeRequest: Entidad.CTipoRequest.Escuela,
            ColumnsConfig: this.ctrlTabla._InfoColumns
                .map(d => ({
                    Field: d.Field as keyof IBoletaPlantilla,
                    HeaderTag: d.Label,
                    WidthCell: 25
                })),
            OnGetDataBySheets: async () => {
                return [{
                    IdSheet: escuela.IdKinder, // IdEscuela
                    SheetName: escuela.Nombre,
                    Data: dataTable,
                }]
            },
            OnGetEscuelasTagInSheet: (datos) => _DICC_ESCUELA.get(escuela.IdKinder).Nombre,
            OnStepFieldInDataRow: (field, dato) => {
                // if ((field == "FechaInicio" || field == "FechaFin") && dato[field]) {
                //     return UIUtilTime._DateFormatStandarFixTimeZone(dato[field], this.cardData[0].ZonaHoraria);
                // }
                if (field == "_Alcance") {
                    return UIUtilElement._CreateElementsFromHTML(dato[field])
                        .map(d => d.textContent)
                        .join("")
                }
                return dato[field] as string;
            }
        }
    }

    // **************************************************************************
    //  SERVICIOS Y DATA
    // **************************************************************************

}

// **************************************************************************
// EXTRAS
// **************************************************************************

type IBoletaPlantillaForm = IBoletaPlantilla & {
    EncabezadosExtras: string[]
    VerMateriaMaestro: boolean
    StaticMateriaMaestro: [string, string, (number[] | null | undefined)][]
}
type FormBoletaPlantilla = {
    idEscuela: number
    idBoletaPlantilla?: number | null
    getAlreadyConfigs: () => IBoletaPlantilla[]
}
type RelMateriaMaestroRow = {
    materia: string
    maestro: string
    idsGrupo: number[] | null
}
const createForm = ({ idEscuela, idBoletaPlantilla, getAlreadyConfigs }: FormBoletaPlantilla): FormGenerator<IBoletaPlantillaForm> => {
    let tblEncabezadosExtras: TablaRowManager<{ text: string }>
    let tblRelMateriaMaestro: TablaRowManager<RelMateriaMaestroRow>

    const templateImages: { [k in CBoletaPlantillaBase]: (string)[] } = {
        [CBoletaPlantillaBase.Plantilla1]: [ic_template1_01, ic_template1_02],
        [CBoletaPlantillaBase.Plantilla2]: [ic_template2_01, ic_template2_02, ic_template2_03],
    }

    const boletaSelectedMode = (() => {
        let container: TSelectionHTML,
            idPlantilla: CBoletaPlantillaBase | null
        const updateView = () => {
            container.style("padding", "var(--padding2) var(--padding1)")
            // >> Contenido preview de la plantilla seleccionada

            if (idPlantilla == null) {
                container.html(`<i>${_L("panelboletaconfiguracion.nopreview")}</i>`)
                return
            } else {
                const currentImages = templateImages[idPlantilla]

                select(container.node().parentElement).style("overflow", "hidden")
                container
                    .style("overflow", "auto")
                    .style("width", "100%")
                    .style("display", "flex")
                container.select(":scope>i").remove()

                container.node().addEventListener('wheel', (event => {
                    event.preventDefault()
                    container.node().scrollLeft += event.deltaY
                }));

                container
                    .selectAll<HTMLImageElement, string>("img")
                    .data(currentImages)
                    .join("img")
                    .attr("src", url => url)
                    .style("width", "calc(90px + var(--padding4))")
                    .style("margin", "0 var(--padding2)")
                    .style("cursor", "pointer")
                    .style("object-fit", "contain")
                    .style("border", "1px solid rgba(0, 0, 0, .2")
                    .each((url, i, imgs) => imgs[i].onclick = () => new FullViewFile()
                        ._SetContent(currentImages.map<FullViewItemContent>(url => ({
                            Id: url,
                            Filename: UIUtilViewData._GetStr_BoletaPlantillaBase(idPlantilla),
                            Content: () => url,
                            Download: false,
                        })))
                        ._FocusID(url)
                    )
            }

            // >> MOSTRAR form.fields de configuracion de la plantilla seleccionada

            const fieldsModes: { [k in CBoletaPlantillaBase]: (keyof IBoletaPlantillaForm)[] } = {
                [CBoletaPlantillaBase.Plantilla1]: [],
                [CBoletaPlantillaBase.Plantilla2]: ["VerMateriaMaestro", "EncabezadosExtras", "StaticMateriaMaestro"],
            }
            const fieldMode: (keyof IBoletaPlantillaForm)[] = fieldsModes[idPlantilla]

            for (const fieldModeAux of Object.values(fieldsModes)) {
                if (fieldModeAux === fieldMode) continue

                fieldModeAux.forEach(field => {
                    form._GetModelControl(field).row.classed("hide", true)
                })
            }

            fieldMode.forEach(field => {
                form._GetModelControl(field).row.classed("hide", false)
            })
        }

        return {
            init: (container_) => {
                container = container_
                updateView()
            },
            setIdPlantilla: (idPlantilla_) => {
                idPlantilla = idPlantilla_
                updateView()
            }
        }
    })()

    const form = new FormGenerator<IBoletaPlantillaForm>()
    form._Crear({
        // LabelMaxWidth:
        OnAssignData: ({ IdPlantilla, IdsGrado, EncabezadosExtras, StaticMateriaMaestro }) => {
            boletaSelectedMode.setIdPlantilla(IdPlantilla)
            form._SetModelValue("IdsGrado", IdsGrado)
            tblEncabezadosExtras?._SetData(EncabezadosExtras?.map(d => ({ text: d })))
            tblRelMateriaMaestro?._SetData(StaticMateriaMaestro?.map(([materia, maestro, idsGrupo]) => ({ materia, maestro, idsGrupo })))
        },
        onValideForm: ({ IdsNivel, IdsGrado }) => {
            const alreadyConfigs = getAlreadyConfigs()
            let conflict = false

            for (const { Id, IdsNivel: alreadyIdsNivel, IdsGrado: alreadyIdsGrado } of alreadyConfigs) {
                if (Id == idBoletaPlantilla) continue

                if (IdsNivel === null && IdsGrado === null && alreadyIdsNivel === null && alreadyIdsGrado === null) {
                    NotificacionV2._Mostrar("Ya existe una configuración para toda la escuela", "ADVERTENCIA")
                    conflict = true
                } else if (IdsGrado?.length && alreadyIdsGrado?.length) {
                    const idGradoConflict = IdsGrado.find(idGrado => alreadyIdsGrado.includes(idGrado))
                    conflict = idGradoConflict > 0
                    if (conflict) NotificacionV2._Mostrar(_L("panelboletaconfiguracion.configuracion_existente_grado", _DICC_GRADO.get(idGradoConflict)?.Nombre), "ADVERTENCIA")
                } else if (IdsNivel?.length && alreadyIdsNivel?.length) {
                    const idNivelConflict = IdsNivel.find(idNivel => alreadyIdsNivel.includes(idNivel))
                    conflict = idNivelConflict > 0
                    if (conflict) NotificacionV2._Mostrar(_L("panelboletaconfiguracion.configuracion_existente_nivel", _DICC_ESCOLARIDAD.get(idNivelConflict)?.Nombre), "ADVERTENCIA")
                }
                if (conflict) break
            }
            return !conflict
        },
        schema: [
            {
                model: "Nombre", type: "input", labelText: _L("panelboletaconfiguracion.nombre"),
                inputAttr: { required: true, maxlength: 100, minlength: 1 }
            },
            {
                model: "IdsNivel", type: "selectMaterial", labelText: _L("panelboletaconfiguracion.nivel"),
                selectMaterialAttr: {
                    valueMember: <keyof Entidad.IEscolaridad>"Id",
                    displayMember: <keyof Entidad.IEscolaridad>"Nombre",
                    // required: true,
                    multiselect: true,
                    Data: Array.from(_DICC_ESCOLARIDAD.values()).filter(d => d.IdEscuela == idEscuela),
                    onChange: () => {
                        (form._GetModelControl("IdsGrado").instance as SelectV2)._RefreshList()
                        tblRelMateriaMaestro?._RefreshUI() // Actualiza las listas de grupos en RelMateriaMaestro
                    },
                },
                onValidate: (ids) => (ids == null || ids.length > 0),
                onGetFixedValue: (value: number[]) => {
                    const gradosTotales = (form._GetModelControl("IdsNivel").instance as SelectV2)._dataitems.length
                    if (gradosTotales == value.length) {
                        return null
                    }
                    return value
                }
            },
            {
                model: "IdsGrado", type: "selectMaterial", labelText: _L("panelboletaconfiguracion.grado"),
                selectMaterialAttr: {
                    valueMember: <keyof Entidad.IGrado>"IdNivel",
                    displayMember: <keyof Entidad.IGrado>"Nombre",
                    multiselect: true,
                    Data: () => {
                        const idsNivel = form._GetModelValue("IdsNivel")
                        if (idsNivel == null) {
                            return Array.from(_DICC_GRADO.values()).filter(d => d.IdKinder == idEscuela)
                        }
                        return Array.from(_DICC_GRADO.values()).filter(d => idsNivel.includes(d.IdEscolaridad))
                    },
                    onChange: () => {
                        tblRelMateriaMaestro?._RefreshUI() // Actualiza las listas de grupos en RelMateriaMaestro
                    },
                    OnStepItemListUI: (container, dato: Entidad.IGrado, step) => {
                        if (step == "enter") {
                            container.classed(UIUtilGeneral.FBoxOrientation.Vertical, true);
                            container.style("align-items", "flex-start");
                        }
                        const idsNivel = form._GetModelValue("IdsNivel")
                        const multipleNivel = idsNivel == null ? true : idsNivel.length > 1
                        let html = `<label>${multipleNivel ? _L("general.grado") + ": " : ""}${dato.Nombre}</label>`;
                        if (multipleNivel)
                            html += `<label style='font-size: var(--fontsize_me4)'>${_L("general.nivel")}: ${_DICC_ESCOLARIDAD.get(dato.IdEscolaridad)?.Nombre || _L("general.nodisponible")}</label>`;
                        container.html(html);
                    }
                },
                onValidate: (ids) => (ids == null || ids.length > 0),
                onGetFixedValue: (value: number[]) => {
                    const gradosTotales = (form._GetModelControl("IdsGrado").instance as SelectV2)._dataitems.length
                    if (gradosTotales == value.length) {
                        return null
                    }
                    return value
                }
            },
            {
                model: "IdPlantilla", type: "selectMaterial", labelText: _L("panelboletaconfiguracion.plantilla"),
                onLoad: ({ controlWrapper }) => {
                    const plantillaPreview = controlWrapper.append("div")
                    boletaSelectedMode.init(plantillaPreview)
                },
                selectMaterialAttr: {
                    required: true,
                    valueMember: <keyof IDatoBase>"Id",
                    displayMember: <keyof IDatoBase>"Name",
                    Data: UIUtilViewData._GetList_BoletaPlantillaBase(),
                    onChange: (idPlantilla) => boletaSelectedMode.setIdPlantilla(idPlantilla)
                },
            },
            // CAMPOS DE PLANTILLA 2
            {
                model: "VerMateriaMaestro", type: "input", labelText: _L("panelboletaconfiguracion.vermateriamaestro"),
                onLoad: ({ row }) => row.classed("hide", true),
                inputAttr: { type: "checkbox" }
            },
            {
                model: "EncabezadosExtras", type: "unknown", labelText: _L("panelboletaconfiguracion.encabezadosextras"),
                onLoad: ({ row, controlWrapper }) => {
                    row.classed("hide", true)
                    tblEncabezadosExtras = new TablaRowManager<{ text: string }>({
                        IdTabla: "boleta_config_extra_encabezado",
                        Parent: controlWrapper,
                        Columns: [
                            { Field: "text", Label: "", Width: "80%", MinWidth: "50px" }
                        ],
                        OnStepCellTable: (cell, datum) => {
                            cell.style("width", "100%").text("")

                            const input = cell.append("input")
                                .attr("class", "input-form")
                                .attr("value", datum.text)
                                .attr("max-lenght", "80")

                            input.node().onchange = () => {
                                datum.text = (input.property("value") as string)?.trim() || ""
                            }
                        }
                    })
                },
                onGetFixedValue: () => tblEncabezadosExtras._GetData()
                    .filter(d => !!(d.text?.trim()))
                    .map(d => (d.text))
            },
            {
                model: "StaticMateriaMaestro", type: "unknown", labelText: _L("panelboletaconfiguracion.staticasignaturamaestro"),
                onLoad: ({ row, controlWrapper }) => {
                    row.classed("hide", true)
                    tblRelMateriaMaestro = new TablaRowManager<RelMateriaMaestroRow>({
                        IdTabla: "boleta_config_extra_materiamaestro",
                        Parent: controlWrapper,
                        Columns: [
                            { Field: "materia", Label: _L("panelboletaconfiguracion.materia"), Width: "35%", MinWidth: "50px" },
                            { Field: "maestro", Label: _L("panelboletaconfiguracion.maestro"), Width: "35%", MinWidth: "50px" },
                            {
                                Field: "idsGrupo", Label: _L("panelboletaconfiguracion.grupo"), Width: "30%", MinWidth: "50px",
                                OnLoadHead: (container) => container.call(cont => {
                                    cont.append(() => UIUtilElement._CreateElementFromHTML(ic_info))
                                        .style("width", "var(--padding3)")
                                        .style("height", "var(--padding3)")
                                        .style("margin-left", "var(--padding1)")
                                    cont.append<HTMLTooltipComponent>("wc-tooltip")
                                        .attr("position", "top")
                                        .text(_L("panelboletaconfiguracion.rel_mm_col_grupo_info"))
                                })
                            },
                        ],
                        OnStepCellTable: (cell, datum, field: keyof RelMateriaMaestroRow) => {
                            cell.style("width", "100%").text("")

                            if (field == "maestro" || field == "materia") {
                                const input = cell.append("input")
                                    .attr("class", "input-form")
                                    .attr("value", datum[field])
                                    .attr("max-lenght", "150")

                                input.node().onchange = () => {
                                    datum[field] = (input.property("value") as string)?.trim() || ""
                                }
                            } else if (field == "idsGrupo") {
                                const select = new SelectV2<Entidad.IGrupo, "IdGrupo", "multiselect">({
                                    Parent: cell,
                                    ValueMember: "IdGrupo",
                                    DisplayMember: "Nombre",
                                    ListWidth: "220px",
                                    Type: "multiselect",
                                    Data: () => {
                                        const idsNivel = form._GetModelValue("IdsNivel")
                                        const idsGrado = form._GetModelValue("IdsGrado")
                                        const gruposDisponibles = Array.from(_DICC_GRUPO.values())
                                            .filter(d => (
                                                (d.IdKinder == idEscuela)
                                                && (idsNivel == null || idsNivel.includes(d.IdEscolaridad))
                                                && (idsGrado == null || idsGrado.includes(d.IdNivel))
                                            ))
                                        return gruposDisponibles
                                    },
                                    OnChange: (ids) => {
                                        datum.idsGrupo = (ids.length == select._dataitems.length) ? null : ids
                                    },
                                    OnStepItemListUI: (cont, d) => cont.html(`
                                        <span> ${d.Nombre} </span>
                                        <span style="font-size:var(--fontsize_me4);"><b style="font-size:var(--fontsize_me4);">${_L("general.nivel")}</b>: ${d.NombreEscolaridad}</span>
                                        <span style="font-size:var(--fontsize_me4);"><b style="font-size:var(--fontsize_me4);">${_L("general.grado")}</b>: ${d.NombreGrado}</span>
                                    `.trim())
                                })
                                select._valueSelect((() => {
                                    if (datum.idsGrupo) {
                                        return datum.idsGrupo
                                    } else {
                                        return Array.from(_DICC_GRUPO.values())
                                            .filter(d => d.IdKinder == idEscuela)
                                            .map(d => d.IdGrupo)
                                    }
                                })())
                            }
                        }
                    })
                },
                onGetFixedValue: () => tblRelMateriaMaestro._GetData()
                    .filter(d => !!(d.materia?.trim()) && !!(d.maestro?.trim()))
                    .map(d => ([d.materia, d.maestro, d.idsGrupo]))
            },
        ]
    })
    return form
}